import { i18n } from "services/i18nService";

import { initialErrorState } from "views/common";

export function isValid(record) {
  const errors = initialErrorState();

  if (!record.name?.trim().length) {
    errors.messages.push(i18n("isValid.Name"));
    errors.entity.push("name");
  }

  if (!record.displayOn.length) {
    errors.messages.push(i18n("isValid.DisplayOn"));
    errors.entity.push("displayOn");
  }

  return errors;
}
